const IndexPage = ({ data }) => (
  <main className="raleway gray">
    <Hero data={data.allHeroJson.edges[0].node} />
    <About data={data.allAboutJson.edges[0].node} />
    <Audition data={data.allAuditionJson.edges[0].node} />
    <Numbers data={data.allNumbersJson.edges[0].node} />
    <Account data={data.allAccountJson.edges[0].node} />
    <Subscribe data={data.allSubscribeJson.edges[0].node} />
  </main>
)

/*
 *
 * Imports
 * 
 */

import React from 'react'

import Hero from '../sections/Hero'
import About from '../sections/About'
import Audition from '../sections/Audition'
import Numbers from '../sections/Numbers'
import Account from '../sections/Account'
import Subscribe from '../sections/Subscribe'
;('hero-520519b680e00af68711add272e815ae-f4a2a.webp')

/*
 * 
 * Queries
 *
 */

export const query = graphql`
  query IndexPageQuery {
    allHeroJson {
      edges {
        node {
          heading {
            gray
            gold
          }
          paragraph
          image {
            childImageSharp {
              sizes(maxWidth: 650) {
                ...GatsbyImageSharpSizes_withWebp
              }
            }
          }
          alt
          critical
        }
      }
    }
    allAboutJson {
      edges {
        node {
          heading
          image {
            childImageSharp {
              sizes(maxWidth: 768) {
                ...GatsbyImageSharpSizes_withWebp
              }
            }
          }
          alt
          critical
          slides {
            heading {
              gray
              gold
            }
            paragraph
            features
          }
        }
      }
    }
    allAuditionJson {
      edges {
        node {
          heading
          image {
            childImageSharp {
              sizes(maxWidth: 768) {
                ...GatsbyImageSharpSizes_withWebp
              }
            }
          }
          alt
          critical
          slides {
            heading {
              gray
              gold
            }
            paragraph
            features
          }
        }
      }
    }
    allNumbersJson {
      edges {
        node {
          heading
          subheading {
            gray
            gold
          }
          paragraph
          features
          stats
        }
      }
    }
    allAccountJson {
      edges {
        node {
          heading
          paragraph
          artist {
            type
            features
          }
          company {
            type
            features
          }
          image {
            childImageSharp {
              sizes(maxWidth: 768) {
                ...GatsbyImageSharpSizes_withWebp
              }
            }
          }
          alt
          critical
        }
      }
    }
    allSubscribeJson {
      edges {
        node {
          heading
          subheading {
            gray
            gold
          }
          paragraph
        }
      }
    }
  }
`

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js